import { render, staticRenderFns } from "./RecentView.vue?vue&type=template&id=46622bf4&"
import script from "./RecentView.vue?vue&type=script&lang=js&"
export * from "./RecentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports